import { ApolloError, useMutation } from "@apollo/client"
import { useAppDispatch } from "../../../store/app/hooks"
import {
  setCloseAlert,
  setLoadingDelete,
  setOpenAlert,
} from "../../../store/features/alert/alertSlice"
import { havePermissions } from "../../../utils/permissions"
import SwitchButton from "../SwitchButton/SwitchButton"
import { setOpenSnackbar } from "../../../store/features/snackbar/snackbarSlice"
import { getErrorsAsString } from "../../../utils/getErrorsAsString"
import { Maybe } from "../../../gql/graphql"
import { graphql } from "../../../gql"
import useLang from "../../../hooks/useLang"

const UPDATE = graphql(`
  mutation UpdateOneFaqVisibility(
    $data: FaqUpdateInput!
    $where: FaqWhereUniqueInput!
  ) {
    updateOneFaq(data: $data, where: $where) {
      id
      isShowOnCraftman
      isShowOnCustomer
      priority
    }
  }
`)

const ToogleShowFaq = ({
  isShow,
  id,
  type,
}: {
  isShow?: Maybe<boolean> | undefined
  type: "customer" | "craftman"
  id: number
}) => {
  const dispatch = useAppDispatch()
  const [updateEvent] = useMutation(UPDATE)
  const { getText } = useLang()

  const onCompleted = () => {
    dispatch(
      setOpenSnackbar({
        message: getText("La modification a été faite avec succès"),
        status: "success",
      }),
    )
    dispatch(setLoadingDelete(false))
    dispatch(setCloseAlert())
  }

  const onError = (err: ApolloError) => {
    const message = getErrorsAsString(err)
    dispatch(setCloseAlert())
    dispatch(setOpenSnackbar({ message }))
  }

  const handleToogle = (id: number, isActive: boolean) => {
    dispatch(setLoadingDelete(true))
    const isActiveState = !isActive
    updateEvent({
      variables: {
        data: {
          ...(type === "craftman" && {
            isShowOnCraftman: {
              set: isActiveState,
            },
          }),
          ...(type === "customer" && {
            isShowOnCustomer: {
              set: isActiveState,
            },
          }),
        },
        where: {
          id,
        },
      },
      onCompleted: onCompleted,
      onError: onError,
      update(cache, { data }) {
        const dataFaq = data?.updateOneFaq
        if (dataFaq) {
          cache.modify({
            id: cache.identify({
              __typename: "Faq",
              id: id,
            }),
            fields: {
              isShowOnCraftman() {
                return dataFaq.isShowOnCraftman
              },
              isShowOnCustomer() {
                return dataFaq.isShowOnCustomer
              },
            },
          })
        }
      },
    })
  }

  const handleShowAlert = (id: number, isActive: boolean) => {
    dispatch(
      setOpenAlert({
        handleValid: () => handleToogle(id, isActive),
        message:
         getText("Êtes-vous sûr de vouloir modifier le statut de visibilité de ce faq ?"),
        isLoading: false,
      }),
    )
  }

  return (
    <SwitchButton
      checked={Boolean(isShow)}
      handleChange={() => {
        if (havePermissions(["faqs.change"])) {
          handleShowAlert(id, Boolean(isShow))
        }
      }}
      disabled={!havePermissions(["faqs.change"])}
      id={`isShow-${id.toString()}`}
    />
  )
}

export default ToogleShowFaq
